module.exports = __webpack_public_path__ + "static/media/logo.1fb547d9.png";